var render = function render(){var _vm=this,_c=_vm._self._c;return (this.params.data && !this.params.data.hideLink)?_c('b-button',{staticClass:"icon-button app-ctrl-border",attrs:{"pill":"","variant":"outline-primary"},on:{"click":_vm.handler}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'arrow-alt-right' ]}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }